import React from 'react';
import ReactDOM from 'react-dom';

import HamburgMenuComp from '../hamburgmenu';
import TopMenuConst from '../../navbar/constants/top_menu.constants';
import ViewEndPopup from './modals/viewEndPopup';
import ViewDeletePopup from './modals/viewDeletePopup';
import PublishSummaryMeeting from './publishSummaryMeeting';

// Meeting Top Menu
class MainMenuTopMeeting extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dateDropdown: this.props.dateDropdown,
      isTeamManager: this.props.isTeamManager,
      openMeetingExists: this.props.openMeetingExists,
      menuOpts: this.props.menuOpts,
      meetingObj: this.props.meetingObj,
    }
    this.deleteHandler = this.deleteHandler.bind(this);
    this.closeWsPopup = this.closeWsPopup.bind(this);
    this.deleteMeeting = this.deleteMeeting.bind(this);
    this.publishSummary = this.publishSummary.bind(this);
    this.openInWobo = this.openInWobo.bind(this);
    this.pastMeeting = this.pastMeeting.bind(this);
    this.viewMeeting = this.viewMeeting.bind(this);
    this.addRecurringTopics = this.addRecurringTopics.bind(this);
    this.removeRecurringTopics = this.removeRecurringTopics.bind(this);
    this.editMeeting = this.editMeeting.bind(this);
    this.pingAgenda = this.pingAgenda.bind(this);
    this.updateMeetingPopupData = this.updateMeetingPopupData.bind(this)
    this.sendMail = this.sendMail.bind(this);
    this.askForRate = this.askForRate.bind(this);
  }

  deleteHandler() {
    topmenuDeleteObject(TopMenuConst.OBJECT_TYPE_MEETING, this.props.meetingObj.id, 'meeting');
    delete_meeting_confirm.dialog('open');
    if (document.getElementById('delete-meeting-confirm-box')) {
      ReactDOM.unmountComponentAtNode(document.getElementById('delete-meeting-confirm-box'));
    }
    ReactDOM.render(<ViewDeletePopup meetingObj={this.props.meetingObj} deleteMeeting={this.deleteMeeting} />, document.getElementById('delete-meeting-confirm-box'));
  }

  closeWsPopup() {
    if (document.getElementById('delete-meeting-confirm-box')) {
      ReactDOM.unmountComponentAtNode(document.getElementById('delete-meeting-confirm-box'));
    }
    $(delete_meeting_confirm).dialog('close');
  }

  deleteMeeting(type) {
    const meetingId = this.props.meeting.id;
    const meetingType = this.props.meeting.type;
    const url = wbConfig.baseUrl + '/meeting/deleteMeeting';

    $(this).attr('disabled', 'disabled');
    if (typeof url !== 'undefined') {
      $.ajax({
        url,
        type: 'post',
        data: { id: meetingId , deletetype : type },
      })
        .done((response) => {
          if (response.error) {
            alert(response.error);
          } else {
            delete_meeting_confirm.dialog('close');
            let _url = '';
            if (meetingType == '1') {
              _url = `${wbConfig.baseUrl}/meeting/1on1smeeting?cs=1`;
              if ($('.memberPage').length) {
                wbLeftMenuActive(_url);
                return false;
              }
            } else {
              _url = `${wbConfig.baseUrl}/meeting/index`;
            }
            // const containerId = $('.meeting-list-page');
            ajaxPageLoad(_url, undefined, undefined, undefined, 'menu-wb-mymeeting');
          }
        })
        .fail((response) => {
          // TODO!: system alerts are an unacceptable way to provide feedback
          alert('Oops something went wrong. Please try again later.');
          delete_meeting_confirm.dialog('close');
        });
    }
  }

  publishSummary() {
    activeLeftMenuId('');
    ReactDOM.render(<PublishSummaryMeeting
      meetingObj={this.props.meetingObj}
      meeting={this.props.meeting}
      selectedUser={this.props.selectedUser}
      currentUser={this.props.currentUser}
      meeting_topics={this.props.meeting_topics}
      meeting_takes={this.props.meeting_takes}
      meeting_invitees={this.props.meeting_invitees}
      dateDropdown={this.props.dateDropdown}
      printMeeting={this.props.printMeeting}
    />, document.getElementById('msDetailsPage'));
  }

  openInWobo() {
    const _url = `${wbConfig.baseUrl}/meeting/meetingDetails?id=${this.props.meetingObj.id}`;
    window.open(_url, 'openmeet');
  }

  pastMeeting() {
    const dataType = this.props.meeting.type;
    let _url = '';
    if (typeof dataType !== 'undefined') {
      containerId = $('.meeting-list-page');
      $(document).trigger('unmount_meeting_app_comp');
      if (dataType == '1') {
        _url = `${wbConfig.baseUrl}/meeting/1on1smeeting?cs=2`;
        wbLeftMenuActive(_url);
      } else {
        _url = `${wbConfig.baseUrl}/meeting/meeting?cs=2`;
        ajaxPageLoad(_url, undefined, undefined, containerId, 'menu-wb-mymeeting');
      }
      highlightLeftMenuNav('meeting', 'meeting_pastmeetings');
    }
    return false;
  }

  viewMeeting() {
    const dataType = this.props.meeting.type;
    let _url = '';
    let leftMenuHighMeeting = '';
    if (typeof dataType !== 'undefined') {
      containerId = $('.meeting-list-page');
      $(document).trigger('unmount_meeting_app_comp');
      if (dataType == '1') {
        _url = `${wbConfig.baseUrl}/meeting/1on1smeeting?cs=1`;
        leftMenuHighMeeting = 'meeting_1on1s';
        wbLeftMenuActive(_url);
      } else {
        _url = `${wbConfig.baseUrl}/meeting/meeting?cs=1`;
        leftMenuHighMeeting = 'meeting_meetings';
        ajaxPageLoad(_url, undefined, undefined, containerId, 'menu-wb-mymeeting');
      }
      highlightLeftMenuNav('meeting', leftMenuHighMeeting);
    }
    return false;
  }

  addRecurringTopics() {
    const { meeting } = this.props;
    const { actions } = this.props;
    const value = 1;
    $('.thirdDiv .wspopupmenu-wrapper').hide();
    $.post(`${wbConfig.baseUrl}/meeting/addRecurringTopics`, { id: meeting.id });
    actions.MeetingAllItemAddRemoveRecurring(meeting.id, value);
  }

  removeRecurringTopics() {
    const { meeting } = this.props;
    const { actions } = this.props;
    const value = 0;
    actions.MeetingAllItemAddRemoveRecurring(meeting.id, value);
    $('.thirdDiv .wspopupmenu-wrapper').hide();
    $.post(`${wbConfig.baseUrl}/meeting/removeRecurringTopics`, { id: meeting.id });
  }

  editMeeting() {
    const { meeting } = this.props;
    const mid = this.props.meeting.id;
    if (meeting.type == '1') {
      editOneOneScheduled(mid, null, this.updateMeetingPopupData);
    } else {
      const tid = this.props.meeting.team_id;
      teamMeetingEdit(tid, mid, this.updateMeetingPopupData);
    }
  }

  pingAgenda() {
    const mid = this.props.meeting.id;
    $('.thirdDiv .wspopupmenu-wrapper').hide();
    $.post(wbConfig.baseUrl + '/meeting/pingTeam', { meetingId: mid }, () => {
      infoPopup.call(' Just fired off your reminder! ', 3000)
    });
  }

  updateMeetingPopupData(data) {
    const { actions } = this.props;
    actions.MeetingUpdatePopupData(data);
  }

  sendMail() {
    const { actions } = this.props;
    const sendSum = 1;
    delete_meeting_confirm.dialog('open');
    if (document.getElementById('delete-meeting-confirm-box')) {
      ReactDOM.unmountComponentAtNode(document.getElementById('delete-meeting-confirm-box'));
    }
    ReactDOM.render(<ViewEndPopup meetingObj={this.props.meeting} endMeetingOnce={this.endMeetingOnce} future={this.props.future} sendSum={sendSum} actions={actions} />, document.getElementById('delete-meeting-confirm-box'));
  }

  askForRate() {
    const { actions } = this.props;
    const sendSum = 1;
    const future = 0;
    const sendMinute = 1;
    delete_meeting_confirm.dialog('open');
    if (document.getElementById('delete-meeting-confirm-box')) {
      ReactDOM.unmountComponentAtNode(document.getElementById('delete-meeting-confirm-box'));
    }
    ReactDOM.render(<ViewEndPopup meetingObj={this.props.meeting} endMeetingOnce={this.endMeetingOnce} future={future} sendSum={sendSum} sendMinute={sendMinute} actions={actions} />, document.getElementById('delete-meeting-confirm-box'));
  }

  render() {
    const menu = { mainmenu: 1, items: [] };
    const { dateDropdown } = this.props;
    const { meeting } = this.props;
    const { userPermission } = this.props;
    const { extraStyles } = this.props
    let fromWhere = null;
    const currentAddressBarUrl = window.location.href;
    if (typeof currentAddressBarUrl !== 'undefined' && currentAddressBarUrl.indexOf('from_where=msteams') != -1) {
      fromWhere = 'msteams';
    }
    menu.items.push({
      title: 'Publish Summary',
      handler: this.publishSummary,
      spriteClass: 'icon icon-outline-publish-24px'
    });
    let deleteOption = {};
    if (meeting.status == '1') {
      if (meeting.type == '1' && userPermission.meetingAccess) {
        menu.items.push({
          title: 'Edit',
          class: 'publishTeamBoard team-meeting-edit',
          handler: this.editMeeting,
          spriteClass: 'icon icon-outline-edit-24px'
        });
        deleteOption = {
          title: 'Delete',
          handler: this.deleteHandler,
          class: 'delete-meeting-link',
          spriteClass: 'icon icon-outline-delete_outline-24px'
        };
      }
      if (meeting.type != '1' && userPermission.currentUserSubscription && userPermission.meetingAccess) {
        menu.items.push({
          title: 'Edit',
          class: 'team-meeting-edit',
          spriteClass: 'icon icon-outline-edit-24px',
          handler: this.editMeeting
        });
        deleteOption = {
          title: 'Delete',
          handler: this.deleteHandler,
          class: 'delete-meeting-link',
          pic: 'close_meeting',
          width: '20',
          height: '20',
        };
      }

      if (meeting.type == '1' || meeting.team_contribution == '1') {
        menu.items.push({
          title: 'Ping for agenda',
          class: 'ping-for-agenda',
          pic: 'ping',
          handler: this.pingAgenda,
          width: '20',
          height: '20',
        });
      }

      if (userPermission.meetingAccess && meeting.interval > 0) {
        menu.items.push({
          title: 'Make all topics recurring',
          handler: this.addRecurringTopics,
          class: 'recurringMeeting ',
          spriteClass: 'icon icon-outline-add_circle_outline-24px'
        });
        menu.items.push({
          title: 'Remove recurring topics',
          handler: this.removeRecurringTopics,
          class: '',
          spriteClass: 'icon icon-outline-remove_circle_outline-24px'
        });
      }
    }
    if (meeting.type == '1' && userPermission.meetingAccess) {
      deleteOption = {
        title: 'Delete',
        handler: this.deleteHandler,
        class: 'delete-meeting-link',
        spriteClass: 'icon icon-outline-delete_outline-24px'
      };
    }
    if (meeting.type != '1' && userPermission.currentUserSubscription && userPermission.meetingAccess) {
      deleteOption = {
        title: 'Delete',
        handler: this.deleteHandler,
        class: 'delete-meeting-link',
        spriteClass: 'icon icon-outline-delete_outline-24px'
      };
    }
    /*const viewMeetingText = (meeting.type == '1') ? 'View 1on1s' : 'View meetings';
    menu.items.push({
      title: viewMeetingText,
      handler: this.viewMeeting,
      class: 'viewmeetings-menu-link',
      pic: 'view_meeting',
      width: '15',
      height: '15',
    });
    if (dateDropdown.length) {
      const PastMeetingText = (meeting.type == '1') ? 'Past 1on1s' : 'Past meetings';
      menu.items.push({
        title: PastMeetingText,
        handler: this.pastMeeting,
        class: '',
        pic: 'past_meeting',
        width: '20',
        height: '20',
      });
    }*/
    if (Object.keys(deleteOption).length) {
      menu.items.push(deleteOption);
    }
    if (fromWhere) {
      menu.items = [];
      menu.items.push({
        title: 'Open in Workboard',
        handler: this.openInWobo,
        class: '',
        pic: 'publish_meeting',
        width: '20',
        height: '20',
      });
    }
    return <HamburgMenuComp style={extraStyles} key={`${meeting.id}_${meeting.modified_at}`} menu={menu} />;
  }
}
export default MainMenuTopMeeting;
